export const normalizeList = (value) => (Array.isArray(value) ? value.filter(Boolean) : []);

export const parseConstraints = (value) =>
  String(value || '')
    .split('\n')
    .map((item) => item.trim())
    .filter(Boolean);

export const getPromptTitle = (prompt) =>
  prompt?.input_summary?.title ||
  prompt?.context?.projectTitle ||
  prompt?.context?.courseTitle ||
  'Saved prompt';

export const getPromptLinkIds = (prompt) => {
  const ids = [
    ...normalizeList(prompt?.context?.linkedPromptIds),
    ...(prompt?.context?.linkedPromptId ? [prompt.context.linkedPromptId] : []),
  ];

  return [...new Set(ids.filter(Boolean).map((value) => String(value)))];
};

export const buildPromptTags = (prompt) => {
  const candidateTags = [
    ...(Array.isArray(prompt?.metadata?.tags) ? prompt.metadata.tags : []),
    prompt?.generation_mode,
    prompt?.input_summary?.desiredOutput,
    prompt?.context?.courseTitle,
  ];

  return [...new Set(candidateTags.filter(Boolean).map((tag) => String(tag).trim()))].slice(0, 4);
};

export const formatScalarValue = (value) => {
  if (value === null || value === undefined || value === '') return '--';
  if (typeof value === 'boolean') return value ? 'true' : 'false';
  if (Array.isArray(value)) return value.join(', ') || '--';
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
};
